export default __webpack_public_path__ + "static/media/logo.bb6b64ec.svg";